import './polyfills';

// Components
import AnimatedHeading from './components/animated-heading';
import BookYourStay from './components/book-your-stay';
import CookieBanner from './components/cookie-banner';
import DetailHero from './components/detail-hero';
import DetailNavigation from './components/detail-navigation';
import DotsCarousel from './components/dots-carousel';
import DropdownField from './components/dropdown-field';
import FancyModal from './components/fancy-modal';
import FavoriteProperty from './components/favorite-property';
import FilterableSearch from './components/filterable-search';
import Field from './components/field';
import Footer from './components/footer';
import Form from './components/form';
import FormField from './components/form-field';
import FloatingContactButton from './components/floating-contact-button';
import FloatingFlagCta from './components/floating-flag-cta';
import FloatingLabelField from './components/floating-label-field';
import Galleries from './components/galleries';
import GolfCourseDetails from './components/golf-course-details';
import Header from './components/header';
import Hero from './components/hero';
import Highlights from './components/highlights';
import HomepageHero from './components/homepage-hero';
import ImageCarousel from './components/image-carousel';
import ImageCarouselAlt from './components/image-carousel-alt';
import InteractiveMap from './components/interactive-map';
import InteractiveMapCallout from './components/interactive-map-callout';
import KioskContact from './components/kiosk-contact';
import KioskModalClose from './components/kiosk-modal-close';
import KioskNav from './components/kiosk-nav';
import KioskScreensaver from './components/kiosk-screensaver';
import KioskTimeline from './components/kiosk-timeline';
import KioskTimelineOverview from './components/kiosk-timeline-overview';
import KioskTimelineStandard from './components/kiosk-timeline-standard';
import KioskWelcome from './components/kiosk-welcome';
import Link from './components/link';
import ListCarousel from './components/list-carousel';
import Loader from './components/loader';
import Main from './components/main';
import MapListings from './components/map-listings';
import Modal from './components/modal';
import Navigation from './components/navigation';
import PageCard from './components/page-card';
import PaginatedSearch from './components/paginated-search';
import Plan from './components/plan-card';
import PreferenceForm from './components/preference-form';
import ProcessSteps from './components/process-steps';
import PropertyHero from './components/property-hero';
import PropertyMap from './components/property-map';
import PropertySearch from './components/property-search';
import PropertiesMap from './components/properties-map';
import QuoteCallout from './components/quote-callout';
import RecentReleasesInteractiveMap from './components/recent-releases-interactive-map';
import ReynoldsInsiderStarterForm from './components/reynolds-insider-starter-form';
import SliderCarousel from './components/slider-carousel';
import SaveSearchButton from './components/save-search-button';
import SaveSearchForm from './components/save-search-form';
import UserForm from './components/user-form';
import Video from './components/video';
import VisitFrom from './components/visit-form';

// Utilities
import { evaluate, instantiate } from './utilities/components';
import { events, emitEvent } from './utilities/custom-events';
import { enableAmobeePixels } from './utilities/events';
import { enableAmobeeAwarenessPixels } from './utilities/awareness';

/* eslint-disable quote-props */
const classMap = {
    'animated-heading': AnimatedHeading,
    'book-your-stay': BookYourStay,
    'cookie-banner': CookieBanner,
    'detail-hero': DetailHero,
    'detail-navigation': DetailNavigation,
    'dots-carousel': DotsCarousel,
    'dropdown-field': DropdownField,
    'fancy-modal': FancyModal,
    'favorite-property': FavoriteProperty,
    'field': Field,
    'filterable-search': FilterableSearch,
    'footer': Footer,
    'form': Form,
    'form-field': FormField,
    'floating-contact-button': FloatingContactButton,
    'floating-flag-cta': FloatingFlagCta,
    'floating-label-field': FloatingLabelField,
    'galleries': Galleries,
    'golf-course-details': GolfCourseDetails,
    'header': Header,
    'hero': Hero,
    'highlights': Highlights,
    'homepage-hero': HomepageHero,
    'image-carousel': ImageCarousel,
    'image-carousel-alt': ImageCarouselAlt,
    'interactive-map': InteractiveMap,
    'interactive-map-callout': InteractiveMapCallout,
    'kiosk-contact': KioskContact,
    'kiosk-modal-close': KioskModalClose,
    'kiosk-nav': KioskNav,
    'kiosk-screensaver': KioskScreensaver,
    'kiosk-timeline': KioskTimeline,
    'kiosk-timeline-overview': KioskTimelineOverview,
    'kiosk-timeline-standard': KioskTimelineStandard,
    'kiosk-welcome': KioskWelcome,
    'link': Link,
    'list-carousel': ListCarousel,
    'loader': Loader,
    'modal': Modal,
    'main': Main,
    'map-listings': MapListings,
    'navigation': Navigation,
    'page-card': PageCard,
    'paginated-search': PaginatedSearch,
    'plan-card': Plan,
    'preference-form': PreferenceForm,
    'process-steps': ProcessSteps,
    'property-hero': PropertyHero,
    'property-map': PropertyMap,
    'property-search': PropertySearch,
    'properties-map': PropertiesMap,
    'quote-callout': QuoteCallout,
	'recent-releases-interactive-map': RecentReleasesInteractiveMap,
    'reynolds-insider-starter-form': ReynoldsInsiderStarterForm,
    'slider-carousel': SliderCarousel,
    'save-search-button': SaveSearchButton,
    'save-search-form': SaveSearchForm,
    'user-form': UserForm,
    'video': Video,
    'visit-form': VisitFrom,
};
/* eslint-enable quote-props */

// Event handler functions
function handleDOMConentLoaded() {
    // Call component constructors
    instantiate(classMap);
    enableAmobeePixels();
    enableAmobeeAwarenessPixels();
}

// Add event listeners
document.addEventListener('DOMContentLoaded', handleDOMConentLoaded);
document.addEventListener('afterBlitzInject', event => {
    evaluate(event.detail.element);
    instantiate(classMap);
});
